import { storeToRefs } from 'pinia';
import { ref } from 'vue';

import { useWebSocketStore } from '@/stores/MCPWebsocketStore';

export function useAIChatState() {
  const wsStore = useWebSocketStore();
  const { parsedMessages } = storeToRefs(wsStore);

  const isWaitingOnResponse = ref(false);
  const hasReceivedFirstResponse = ref(false);
  const nextMessage = ref('');

  const receivedMessagesInOrder = ref<
    { role: 'user' | 'bot'; content: string }[]
  >([]);
  const currentMessageEndIndex = ref(0);

  return {
    receivedMessagesInOrder,
    currentMessageEndIndex,
    wsStore,
    parsedMessages,
    isWaitingOnResponse,
    nextMessage,
    hasReceivedFirstResponse,
  };
}
